const dataUpload = {
  wizard: {
    fileUpload: {
      title: '1. Datei-Upload',
      body: {
        btn: 'Hochladen',
        hint: 'Wählen Sie die zu importierende CSV-Datei aus',
        downloadExample: 'CSV-Beispiel herunterladen',
        templateLabel: 'Mapping-Vorlage auswählen (optional)',
        templateDescription: 'Vorlage geladen. Sie können die Konfiguration unten bei Bedarf ansehen oder bearbeiten.',
        advanced: {
          hint: 'Wählen Sie die zu importierenden Dateien aus',
        },
      },
    },
    mappingFields: {
      title: '2. Felder zuordnen',
      subTitle: 'Bestätigen Sie, dass jedes Attribut der richtigen Spalte zugeordnet ist',
      toast: 'Duplizierter Wert',
      selectInputPlaceHolder: 'Feld auswählen'
    },
    integrityCheck: {
      title: '3. Integritätsprüfung',
      subTitle: 'Überprüfen der Dateiwerte',
    },
    import: {
      title: '4. Import',
      subTitle: 'Importieren der Daten',
      doneText: 'Datei erfolgreich importiert',
      doneBtn: 'Erledigt',
    },
  },

  mappingFields: {
    table: {
      fieldsInDb: 'Felder in der Datenbank',
      csvFile: 'CSV-Datei',
      format: 'Format',
      defaultValue: 'Standardwert',
    },
    hideTableBtn: 'Tabelle ausblenden',
    showTableBtn: 'Tabelle anzeigen',
    saveAsTemplateBtn: 'Als Vorlage speichern',
    templateNameLabel: 'Vorlagenname',
    saveTemplateDescription: 'Speichern Sie Ihre aktuellen Feldzuordnungen als Vorlage zur zukünftigen Verwendung.',
    updateTemplateDescription: 'Sie können die vorhandene Vorlage {{templateName}} aktualisieren oder als neue Vorlage speichern.',
    saveTemplateBtn: 'Speichern',
    saveAsNewBtn: 'Als neu speichern',
    updateTemplateBtn: 'Vorlage aktualisieren',
    nextBtn: 'Nächste',
  },

  integrityCheck: {
    showOnlyProblemBtn: 'Nur Probleme anzeigen',
    disableSubmit: 'Fehler überspringen',
    totalCount: 'Gesamt: {{count}}',
    exportErrorList: 'Fehlerliste exportieren',
    rowContainErroe: '{{count}} Zeile enthält Fehler.',
    importBtn: 'Importieren',
    sourceFileColumn: 'Quelldatei',
    sourceRowColumn: 'Quellzeile',
    sourceFileFilterAll: 'Alle {{count}} Quelldateien',
  },

  submit: {
    errors: '{{errors}} Zeilen konnten nicht gepusht werden',
  }
};

export default dataUpload;
